import { render, staticRenderFns } from "./safetyList.vue?vue&type=template&id=ff97421a&scoped=true"
import script from "./safetyList.vue?vue&type=script&lang=js"
export * from "./safetyList.vue?vue&type=script&lang=js"
import style0 from "./safetyList.vue?vue&type=style&index=0&id=ff97421a&prod&lang=scss"
import style1 from "./safetyList.vue?vue&type=style&index=1&id=ff97421a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff97421a",
  null
  
)

export default component.exports